import React from 'react'
import * as ReactDOM from 'react-dom'
import { withStyles, withWidth } from '@material-ui/core'
import grounding_empty from '../../media/grounding/Colouring-Empty.svg'
import SVGInline from 'react-svg-inline'
import PopupDialog from '../PopupDialog'
import { scrollToTop } from './ArticlePointMapSegment'

export const GROUNDING = 'GROUNDING'

const styles = theme => ({
  caption: {
    margin: 20,
  },
  pointsBackground: {
    margin: '0 auto',
    flex: 1
  },
  pyramidContainer: {
    display: 'flex',
    maxWidth: 1260
  },
  pyramidImage: {
    width: '50%',
    maxWidth: 630,
    minHeight: 1200

  },
  pyramidSvgContainer: {
    height: 170,
  },
  pyramidChoices: {
    width: '50%',
    maxWidth: 630
  },
  sortableList: {},

  sortableItem: {
    margin: '10px',
    textAlign: 'justify',
    paddingLeft: 5,
    borderLeft: 'black solid',
    minHeight: 160
  },
  SortableItemHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    // margin: 5,
    padding: 3,
    textTransform: 'uppercase'
  },
  svg: {
    width: '100%',
    display: 'block',
    backgroundColor: '#EDEDED',
  },
  polygon: {
    fill: theme.palette.common.white,
    // fill: 'grey',
    stroke: theme.palette.divider,
    strokeWidth: 1,
  },
  svgText: {
    backgroundColor: '#F90000',
    color: 'white'
  },
  pyramidHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    display: 'block',
    position: 'relative',
    padding: 5,
    textAlign: 'center'
  },
  symbolsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    // width: '50%'
  },
  symbolCard: {
    borderStyle: 'solid',
    borderWidth: 26,
    borderColor: 'brown',
    width: 300,
    height: 450,
    margin: 5,
    alignContent: 'center',
    position: 'relative',
  },
  symbolCardImage: {
    width: '100%',
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
    // margin: '0 5%'
    padding: '5%'
  },
  symbolCardText: {
    textAlign: 'center',
    padding: 10,
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
  },
  draggableText: {
    margin: 3
  },
  dropTarget: {
    // backgroundColor: 'green',
  },
  barometerAgree: {},
  barometerAgreeQuestion: {
    width: '100%'
  },
  barometerGauge: {
    margin: '0 auto'
  },
  formsetRow: {
    justifyContent: 'space-around'
  }

})

const image_map = [
  { // Title
    x1: 0, y1: 250, x2: 200, y2: 475,
    title: 'TITLE',
    question: 'What experiences (professional, life, educational, etc.) give the author credits and qualifications to wrote on this topic?'
  },
  { // Author
    x1: 200, y1: 250, x2: 465, y2: 320,
    title: 'AUTHOR',
    question: 'Is this a new source about the recent event(s)? Or is this a new source about the past event that has a significant meaning now?'
  },
  { // Date
    x1: 225, y1: 10, x2: 375, y2: 25,
    title: 'DATE',
    question: 'Where is this source published? What are other (similar) sources published in this media? Who is the target audience?'
  },
  { // Source
    x1: 205, y1: 400, x2: 330, y2: 535,
    title: 'SOURCE',
    question: 'How does it reflect author\'s background? What are the key words?'
  },
]

/*
skin #FBE5D7
brown #843C0C
light  #F5B087
*/

//skin
const skin = [
  'Describe your current surrounding in detail.',
  'Alphabet focus: go through the alphabet thinking of different things such as types food, countries, cities, names (from A-Z); say alphabet backwards, without vowels...',
  'Age progression-regression: start with your age and count up/down, trying to imagine yourself and changes at every of those ages.',
  'Describe an everyday activity in detail.',
  'Describe a recipe for the dish.',
  'Imaginne: traffic signs or changing TV channels. Imagining can also be related to the pain: running away from the pain; imagining STOP sign stopping your pain; finding a healing TV channel, etc.',
  'Safety statements:  ‘I am safe now’, ‘I am in this location and the date is….’',
  'Humour: search for funny clips, jokes.',
]

//brown
const brown = [
  'Run warm or cool water over your hands.',
  'Focus on your breathing, notice each inhale and exhale.',
  'Grab tightly onto your chair or bed as hard as you can.',
  'Close your eyes, touch different objects, your pen, your keys etc. ',
  'Put your feet on the ground and feel ‘grounded’, connected to the earth.',
  'Carry an object in your pocket, that you can touch whenever you feel triggered.',
  'Stretching like a tree; start on the ground, squatting down and count to 10 while ‘rising’ up as a tree.',
  'Clench and release your fists.'
]

// light
const light = [
  'Any kind statement - you can write it down and carry in your pocket; set it as a reminder; say it out loud several times a day etc.',
  'Have photos of people you care about or picture them in your mind.',
  'Think of, find and/or create a safe place (real or imagined).',
  'Treat yourself with good dinner; book; concert; walk; conversation; bunch of flowers.',
  'Morning pages: list 5 things that you are grateful in your life.',
]

function mapFromChildren (questions) {
  let map = {
    name: 'hero_map',
    areas: []
  }
  let i = 0
  for (let child of questions) {
    // case study content
    map.areas.push({
      name: i++,
      coords: [child.x1, child.y1, child.x2, child.y2],
      shape: 'rect',
      question: child.question,
      title: child.title,
      answered: false,
      answer: null,
      preFillColor: 'rgba(255, 255, 255, 0.5)',
    })
  }
  return map
}

function fillMapWithDefaults (map) {
  for (let area of map.areas) {
    if (!area.shape) {
      area.shape = 'circle'
    }
    if (!area.preFillColor) {
      area.preFillColor = 'rgba(255, 0, 0, 0.5)'
    }
    if (!area.preFillColor) {
      area.preFillColor = 'rgba(255, 255, 255, 0.5)'
    }
  }
  return map
}

class GroundingSubsegment extends React.Component {
  state = {
    map: null,
    correct: false,
    currentArea: null,
    answers: [],
    avgAnswer: null,
    showDialog: false,
    dialogData: {}
  }

  componentDidMount () {
    let map = fillMapWithDefaults(mapFromChildren(image_map))
    let answers = []
    // for (let question of barometer_questions) {
    //   answers.push({ value: undefined })
    // }
    this.setState({ map, answers })

    let rect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
    setTimeout(() => scrollToTop(this), 500)
    if (!this.boundingRect) {
      this.boundingRect = rect
      this.forceUpdate()
    } else {
      this.boundingRect = rect
    }

    let gauge
    for (let j = 1; j < 6; j++) {
      gauge = document.getElementById('light' + j.toString())
      gauge.addEventListener('click', this.groundingClick('light', j))
    }
    for (let j = 1; j < 9; j++) {
      gauge = document.getElementById('brown' + j.toString())
      gauge.addEventListener('click', this.groundingClick('brown', j))
    }
    for (let j = 1; j < 9; j++) {
      gauge = document.getElementById('skin' + j.toString())
      gauge.addEventListener('click', this.groundingClick('skin', j))
    }
  }

  groundingClick (type, index) {
    return (event) => {
      let text
      switch (type) {
        case 'brown':
          text = brown[index - 1]
          break
        case 'light':
          text = light[index - 1]
          break
        case 'skin':
        default:
          text = skin[index - 1]
          break
      }

      this.setState({ showDialog: true, dialogData: { text } })
      event.currentTarget.setAttribute('visibility', 'hidden')
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.boundingRect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
  }

  render () {
    let {
      className, classes
      // ...props
    } = this.props
    let { dialogData } = this.state

    return <div className={className}>
      <div className={classes.barometerGauge}>
        <SVGInline svg={grounding_empty} component={'div'} width={'100%'}
        />
      </div>
      {dialogData &&
      <PopupDialog actionName='' message={dialogData && dialogData.text}
                   open={!!this.state.showDialog}
                   disableBackdropClick={true}
                   disableEscapeKeyDown={true}
                   handleClose={() => this.setState({ showDialog: false, dialogData: {} })}
                   handleYes={() => {

                   }}
      />}
    </div>
  }
}

export default withWidth()(withStyles(styles, { withTheme: true })(
  GroundingSubsegment
))
